import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHelp = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-2 0A6 6 0 112 8a6 6 0 0112 0z"
	}), /* @__PURE__ */ _jsx("path", { d: "M6.94 8.78s.09-.58.27-.8c.18-.2.46-.43.82-.67.3-.2.53-.38.68-.55a.82.82 0 00.23-.59c0-.6-.39-.89-1.18-.89-.4 0-.72.1-.94.32-.23.21-.34.5-.34.85 0 .11.01.25.04.42a1.48 1.48 0 01-1.17-.21A.8.8 0 015 6c0-.34.12-.67.37-.98.24-.3.58-.55 1-.73.42-.19.89-.28 1.4-.28.5 0 .97.09 1.37.27.41.17.73.41.96.73.23.31.35.68.35 1.08 0 .28-.07.52-.2.74-.13.2-.28.39-.45.53-.17.14-.4.32-.68.52-.26.18-.45.33-.57.43a.47.47 0 00-.16.35v.22c0 .52-.67.8-1.12.58-.45-.22-.33-.67-.33-.67zM7.62 12c-.3 0-.54-.09-.73-.26a.9.9 0 01-.27-.68c0-.27.09-.5.27-.68a1 1 0 01.73-.26c.3 0 .54.09.73.26.2.18.3.4.3.68s-.1.5-.3.68c-.19.17-.43.26-.73.26z" })]
});
export default SvgHelp;
